
import React from 'react';
import { Link } from 'react-router-dom';
import { services, companyInfo } from '../data';
import { CheckCircle2, Phone, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Services = () => {
  return (
    <div className="pt-24 md:pt-40 pb-16">
      {/* Header */}
      <section className="bg-green-50 py-20 md:py-32">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-[2.5rem] font-light text-gray-900 mb-6">Vores Ydelser</h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Vi specialiserer os i alt inden for anlægsarbejde, med særligt fokus på holdbare løsninger og flot finish.
          </p>
        </div>
      </section>

      {/* Detailed Services */}
      <section className="py-24">
        <div className="container mx-auto px-4">
          <div className="space-y-32">
            {services.map((service, index) => (
              <motion.div 
                key={service.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className={`flex flex-col ${index % 2 === 1 ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12 lg:gap-24`}
              >
                {service.image && service.image !== "" && (
                  <div className="flex-1 w-full">
                    <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                      <img 
                        src={service.image} 
                        alt={service.title} 
                        className="w-full h-[400px] md:h-[500px] object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                    </div>
                  </div>
                )}
                
                <div className={`flex-1 space-y-6 ${!service.image ? 'max-w-3xl mx-auto text-center flex flex-col items-center' : ''}`}>
                  <div className="inline-block px-4 py-1.5 bg-green-100 text-green-700 rounded-full text-sm font-bold uppercase tracking-wider">
                    {service.title}
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold text-gray-900">{service.title} af højeste kvalitet</h2>
                  <p className="text-gray-600 text-lg leading-relaxed">
                    {service.description} Hos Smith Have & Anlæg ApS går vi aldrig på kompromis med kvaliteten. 
                    Vi sørger for det korrekte underlag, præcis afretning og en afslutning, der står skarpt.
                  </p>
                  
                  <ul className={`space-y-3 ${!service.image ? 'text-left' : ''}`}>
                    {[
                      "Professionel rådgivning",
                      "Korrekt jordarbejde og fundament",
                      "Materialer af høj kvalitet",
                      "Vi rydder op efter os selv"
                    ].map((item, i) => (
                      <li key={i} className="flex items-center gap-3 text-gray-700 font-medium">
                        <CheckCircle2 size={20} className="text-green-600" />
                        {item}
                      </li>
                    ))}
                  </ul>

                  <div className="pt-6 flex flex-col sm:flex-row items-center sm:items-start gap-4">
                    <Link
                      to={`/ydelser/${service.slug}`}
                      className="inline-flex items-center justify-center gap-2 bg-white border-2 border-green-700 text-green-700 w-[289px] sm:w-fit px-4 py-2 rounded-xl font-bold hover:bg-green-50 transition-all text-xs sm:text-sm"
                    >
                      Læs mere
                      <ArrowRight size={14} />
                    </Link>
                    <a 
                      href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                      className="inline-flex items-center justify-center gap-3 bg-green-700 text-white w-[289px] sm:w-fit px-4 py-2 rounded-xl font-bold hover:bg-green-800 transition-all shadow-lg shadow-[#1b4c2e]/10 text-xs sm:text-sm"
                    >
                      <Phone size={14} />
                      Få tilbud
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA section for custom projects */}
      <section className="py-24 bg-gray-50 border-t border-gray-100">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8">Har du et specielt projekt?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-10">
            Ingen opgave er for lille eller for stor. Vi tager gerne en uforpligtende snak om dine havedrømme 
            og hvordan vi kan gøre dem til virkelighed.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <a 
              href={`mailto:${companyInfo.email}`}
              className="bg-white border border-gray-200 text-gray-900 w-[289px] sm:w-fit px-4 py-2 sm:px-6 sm:py-3 rounded-xl font-bold hover:bg-gray-50 transition-all shadow-sm text-sm sm:text-base inline-flex items-center justify-center"
            >
              Send os en mail
            </a>
            <a 
              href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
              className="bg-green-700 text-white w-[289px] sm:w-fit px-4 py-2 sm:px-6 sm:py-3 rounded-xl font-bold hover:bg-green-800 transition-all shadow-lg shadow-green-200 text-sm sm:text-base inline-flex items-center justify-center"
            >
              Ring {companyInfo.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
